<template>
  <div class="medicine-check-print">
    <b-modal
      no-close-on-backdrop
      centered
      hide-header-close
      hide-footer
      id="filterNormal"
      title="FILTRAR"
    >
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0">
        <h6 class="worksansr upper-text">Data</h6>
        <input type="date" class="form-control" v-model="date" />
      </div>
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0">
        <h6 class="worksansr upper-text">Data final</h6>
        <div class="input-group">
          <input type="date" class="form-control" v-model="end_date" />
          <div class="input-group-pprend">
            <v-btn class="v-dark" @click="end_date = ''">LIMPAR</v-btn>
          </div>
        </div>
      </div>
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0">
        <h6 class="worksansr upper-text">Ordernar por</h6>
        <select v-model="order_by" class="form-control">
          <option value="time">HORÁRIO</option>
          <option value="medicine_name">NOME DO MEDICAMENTO</option>
        </select>
      </div>
      <div
        v-if="!end_date"
        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0"
      >
        <h6 class="worksansr upper-text">Periodicidade</h6>
        <select v-model="frequency" class="form-control">
          <option value="SEMANAL">SEMANAL</option>
          <option value="QUINZENAL">QUINZENAL</option>
          <option value="MENSAL">MENSAL</option>
        </select>
      </div>
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <ErrorsMessages :errors="errors" />
        <b-button class="btn-cancel m-1" @click="$bvModal.hide('filterNormal')"
          >CANCELAR</b-button
        >
        <v-btn
          class="btn-filter-sidebar float-right"
          :disabled="loading"
          @click="handleFilter"
        >
          <i class="fas fa-filter mr-2 text-twenty"></i>
          {{ loading ? "CARREGANDO" : "FILTRAR" }}
        </v-btn>
      </div>
    </b-modal>
    <div class="row">
      <div
        class="
          col-xl-6 col-lg-6 col-md-7 col-sm-9 col-12
          d-flex
          align-items-center
        "
      >
        <h6 class="title-pages">PRESCRIÇÃO - NORMAL</h6>
      </div>
      <div
        class="
          col-xl-6 col-lg-6 col-md-5 col-sm-3 col-12
          d-flex
          justify-content-end
          align-items-center
        "
      >
        <v-btn
          v-if="$store.state.online"
          @click="$bvModal.show('filterNormal')"
          class="btn-filter m-1"
        >
          <i class="fas fa-filter mr-2 text-twenty"></i> FILTRAR</v-btn
        >
        <v-btn
          v-if="prescriptions.length > 0"
          @click="handlePrint"
          class="btn-print m-1"
        >
          <i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
        >
      </div>
    </div>
    <div class="pl-0 pt-0 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
      <b-overlay :show="loading" opacity="0.99">
        <div class="p-5 text-center v-clean" v-if="prescriptions.length == 0">
          <h6 class="upper-text worksansr">Sem resultados!</h6>
        </div>
        <div v-if="prescriptions.length > 0">
          <h6 class="title-one mt-2">
            Prescrição Médica - Validade
            <span class="color-blue">{{
              formatDate(group_prescription_medicine.start_date, false)
            }}</span>
            até
            <span class="color-blue">{{
              formatDate(group_prescription_medicine.end_date, false)
            }}</span>
          </h6>
        </div>
        <div
          :class="[
            'table-responsive',
            prescriptions.length > 0 && 'tableFixHead',
          ]"
        >
          <table v-if="prescriptions.length > 0" class="table table-bordered">
            <thead>
              <th>MEDICAMENTO</th>
              <th class="text-center">HORÁRIO</th>
              <th
                v-for="(item, key) in days"
                :key="key"
                v-show="item"
                class="text-center"
              >
                {{ formatDateDayMonth(item) }}
              </th>
            </thead>
            <tbody>
              <tr
                v-for="(prescription, key) in prescriptions"
                :key="key"
                v-show="prescription.items.length > 0"
              >
                <td style="width: auto; padding: 5px">
                  <h6 class="text-thirteen mb-1">
                    {{ key + 1 }} -
                    <strong>{{ prescription.medicine.medicine_name }}</strong>
                  </h6>
                  <h6 class="legends worksansr mb-0">
                    {{ prescription.medicine.medicine_active_ingredient }}
                  </h6>
                  <h6 class="legends worksansr mb-0">
                    VIA:
                    {{ prescription.medicine.route_of_administration_name }}
                  </h6>
                  <h6
                    v-if="prescription.medicine.instruction"
                    class="legends worksansr mb-0"
                  >
                    {{ prescription.medicine.instruction }}
                  </h6>
                </td>
                <td style="width: auto">
                  <h6
                    class="text-for text-center"
                    v-if="!prescription.prescription_medicine_time.time"
                  >
                    EVENTUAL
                  </h6>
                  <h6
                    class="mb-0 text-for text-center"
                    style="width: auto"
                    v-if="prescription.prescription_medicine_time.time"
                  >
                    {{
                      String(
                        prescription.prescription_medicine_time.time
                      ).substr(0, 5)
                    }}
                  </h6>
                </td>
                <td
                  class="p-0"
                  v-for="(item, k) in prescription.items"
                  :key="k"
                >
                  <div>
                    <Daily
                      v-if="
                        item.status != 'NAO_MOSTRAR' &&
                        item.item.frequency == 'DIARIO'
                      "
                      :item="item"
                    />
                    <Weekly
                      v-if="
                        item.status != 'NAO_MOSTRAR' &&
                        item.item.frequency == 'SEMANAL'
                      "
                      :item="item"
                    />
                    <Monthly
                      v-if="
                        item.status != 'NAO_MOSTRAR' &&
                        item.item.frequency == 'MENSAL'
                      "
                      :item="item"
                    />
                    <Yearly
                      v-if="
                        item.status != 'NAO_MOSTRAR' &&
                        item.item.frequency == 'ANUAL'
                      "
                      :item="item"
                    />
                    <Eventual
                      v-if="item.item.frequency == 'EVENTUAL'"
                      :item="item"
                    />
                  </div>
                  <div class="text-center" v-if="item.check_anticipated == 1">
                    <i class="fas fa-clock icon-check-anticipated"></i>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../../templates/Components/ErrorsMessages";

import Daily from "./View/Daily";

import Eventual from "./View/Eventual";

import Monthly from "./View/Monthly";

import Weekly from "./View/Weekly";

import Yearly from "./View/Yearly";

import api from "../../../../services/api";

import routes from "../../../../routes";

import { formatDate, formatDateDayMonth } from "../../../../lib/format";

import { getStatic } from "../../../../lib/functions";

import moment from "moment";

export default {
  name: "Prescription",
  components: {
    ErrorsMessages,
    Daily,
    Eventual,
    Monthly,
    Weekly,
    Yearly,
  },
  data() {
    return {
      filter: false,
      accessed_offline: false,
      order_by: "time",
      frequency: "QUINZENAL",
      resident_id: "",
      date: moment().format("YYYY-MM-DD"),
      end_date: "",
      dateLabel: moment().format("YYYY-MM-DD"),
      days: [],
      group_prescription_medicine: {},
      prescriptions: [],
      errors: [],
      loading: false,
      isActiveFilter: false,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    moment,
    formatDate,
    formatDateDayMonth,
    async retrieve() {
      const { id } = routes.history.current.params;
      this.resident_id = id;

      let accessed_offline = JSON.parse(
        sessionStorage.getItem("accessed_offline") || !this.$store.state.online
      );

      this.accessed_offline = accessed_offline;

      if (accessed_offline) {
        this.loading = false;
        try {
          let residents = (
            await getStatic("/offline/residents/prescriptions-normal", true)
          ).residents;

          let resident = residents.filter((item) => item.id == id);

          if (resident[0]) {
            if (resident[0].prescriptionNormal) {
              let {
                prescriptionNormal: {
                  days,
                  prescriptions,
                  group_prescription_medicine,
                },
              } = resident[0];

              this.$bvModal.hide("filterNormal");
              this.days = days ? days : [];

              this.prescriptions = prescriptions ? prescriptions : [];
              this.group_prescription_medicine = group_prescription_medicine
                ? group_prescription_medicine
                : {};
              this.dateLabel = this.date;
              this.isActiveFilter = false;
            }
          }
        } catch (errors) {
          this.errors = errors;
        }
      } else {
        await this.get();
      }
    },
    async get() {
      try {
        this.loading = true;
        this.errors = [];

        const { resident_id, date, end_date, order_by, frequency, filter } =
          this;

        let params = {
          resident_id,
          date,
          end_date,
          order_by,
          frequency,
          type: "NORMAL",
          filter,
        };

        const response = await api.get(
          "/rest-home/resident/medicine-check-print",
          {
            params,
          }
        );

        const {
          error,
          errors,
          prescriptions,
          days,
          group_prescription_medicine,
        } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.$bvModal.hide("filterNormal");
          this.days = days;

          this.prescriptions = prescriptions;
          this.group_prescription_medicine = group_prescription_medicine;
          this.dateLabel = date;
          this.isActiveFilter = false;

          if (!this.filter) {
            if (group_prescription_medicine) {
              this.date = moment(group_prescription_medicine.start_date).format(
                "YYYY-MM-DD"
              );
              this.dateLabel = moment(
                group_prescription_medicine.start_date
              ).format("YYYY-MM-DD");
            }
          }
        }

        setTimeout(() => (this.loading = false), 200);
      } catch (error) {
        console.log(error);
      }
    },
    handleFilter() {
      this.filter = true;
      this.get();
    },
    handlePrint() {
      let { resident_id, date, end_date, order_by, frequency } = this;

      if (!end_date) {
        end_date = false;
      }

      let params = {
        resident_id,
        date,
        end_date,
        order_by,
        frequency,
      };

      let route = this.$router.resolve({
        name: "medicine_check_print",
        params,
      });

      window.open(route.href, "_blank");
    },
    handleEvery(every, frequency) {
      let frequencys = {
        DIARIO: "DIA",
        SEMANAL: "SEMANA",
        MENSAL: "MÊS",
        ANUAL: "ANO",
      };

      return `A CADA ${every} ${frequencys[frequency]}`;
    },
  },
};
</script>

<style>
.medicine-check-print .tableFixHead {
  overflow-y: auto;
  height: 500px;
}
.medicine-check-print .tableFixHead thead th {
  background: #fff;
  z-index: 999;
  position: sticky;
  top: 0;
}
.medicine-check-print .medicine {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.medicine-check-print .name {
  font-weight: bold;
}
.medicine-check-print .active-ingredient {
  font-size: 12px;
}
.medicine-check-print .via {
  font-weight: bold;
  font-size: 12px;
}
.medicine-check-print .user {
  transform: rotate(290deg) !important;
  font-size: 8px;
  width: 20px;
}
.medicine-check-print .checked-icon {
  width: 15px;
}
</style>
